import { derived } from 'svelte/store'
import { locale } from './store/stores.js'
import translations from './translations'

export const updateLanguage = (language = 'fi') => {
  localStorage.setItem('locale', language)
  locale.set(language)
}

function translate(locale, key, vars) {
  // const kissa = !locale || locale === "null" ? 'fi' : locale;

  if(!locale || locale === "null") {
    updateLanguage(locale)
  }

  // Throw errors if we're trying to use keys/locales that don't exist.
  if (!key) throw new Error('no key provided to $t()');
  if (!locale) throw new Error( `no translation for key '${key}'`)

  // Get the translation from the translations object.
  let text = translations[locale][key]

  if (!text) throw new Error(`no translation found for ${locale}.${key}`)

  // Replace any passed in variables in the translation string.
  Object.keys(vars).map((k) => {
    const regex = new RegExp(`{{${k}}}`, 'g')
    text = text.replace(regex, vars[k])
  })

  return text
}

export const t = derived(locale, ($locale) => (key, vars = {}) =>
  translate($locale, key, vars)
)
